import { BaseCrudService } from "@/services/base";
import { ZoneRestrictionAllow } from "@/swagger/models";

class ZoneRestrictionAllowService extends BaseCrudService<ZoneRestrictionAllow> {
    constructor() {
        super({
            apiPrefix: "zone-restrictions-allow",
            entityName: "restrictionAllow",
        });
    }

    // async getTeams(zoneRestrictionId: number, axiosOptions?: AxiosRequestConfig): Promise<Team[]> {
    //     try {
    //         const res = await this.axios.get<Team[]>(`/${zoneRestrictionId}/teams`, axiosOptions);
    //         return res.data;
    //     } catch (e) {
    //         this.tosti.error({
    //             message: `Could not retrieve teams for zoneRestriction: ${e.response?.data?.message || e.message}`,
    //         });
    //         throw e;
    //     }
    // }
    //
    // async addTeam(zoneRestrictionId: number, teamId: number, axiosOptions?: AxiosRequestConfig): Promise<void> {
    //     try {
    //         const res = await this.axios.post(`/${zoneRestrictionId}/teams/${teamId}`, axiosOptions);
    //         this.tosti.success({ message: `Team successfully added to zoneRestriction` });
    //         return res.data;
    //     } catch (e) {
    //         this.tosti.error({
    //             message: `Could not add team from zoneRestriction: ${e.response?.data?.message || e.message}`,
    //         });
    //         throw e;
    //     }
    // }
    //
    // async removeTeam(zoneRestrictionId: number, teamId: number, axiosOptions?: AxiosRequestConfig): Promise<void> {
    //     try {
    //         const res = await this.axios.delete(`/${zoneRestrictionId}/teams/${teamId}`, axiosOptions);
    //         this.tosti.success({ message: `Team successfully removed from zoneRestriction` });
    //         return res.data;
    //     } catch (e) {
    //         this.tosti.error({
    //             message: `Could not remove team from zoneRestriction: ${e.response?.data?.message || e.message}`,
    //         });
    //         throw e;
    //     }
    // }

    build(
        fields?: Partial<ZoneRestrictionAllow> & Pick<ZoneRestrictionAllow, "teamId" | "zoneId">,
    ): ZoneRestrictionAllow {
        // @ts-ignore Check out what's going on
        return Object.assign(
            {
                mon: true,
                tue: true,
                wed: true,
                thu: true,
                fri: true,
                sat: false,
                sun: false,
            },
            fields,
        );
    }
}

export const zoneRestrictionAllowService = new ZoneRestrictionAllowService();
